import React from "react";
import { Route, Routes } from "react-router-dom";
import AccountPage from "../pages/AccountPage/AccountPage";
import MyAccountRoutes from "../routes/MyAccountRoutes";
import AppContainer from "../components/AppContainer/AppContainer";
import CreateAccountPage from "../pages/CreateAccountPage/CreateAccountPage";

const AccountRoutes = () => {
  return (
    <AppContainer>
      <Routes>
        <Route path="/" element={<AccountPage />} />
        <Route path="my-account/*" element={<MyAccountRoutes />} />
        <Route path="/create" element={<CreateAccountPage />} />
        <Route path="/view" element={<CreateAccountPage />} />
      </Routes>
    </AppContainer>
  );
};

export default AccountRoutes;
